import { create } from 'zustand';
import { EchartOption } from '../../enums';

export const useAccordionUI = create((set) => ({
  accordionData: null,
  setAccordion: (data: any) => set(() => ({ accordionData: data }))
}));

export const useAddedNewFilterBar = create((set) => ({
  isNewFilter: false,
  setIsNewFilrer: (data: any) => set(() => ({ isNewFilter: data }))
}));

export const useViewSelected = create((set) => ({
  viewSelected: null,
  setViewSelected: (data: any) => set(() => ({ viewSelected: data }))
}));

export const useBreakDownSelected = create((set) => ({
  breakDownSelected: null,
  setBreakDownSelected: (data: any) => set(() => ({ breakDownSelected: data }))
}));

export const useReportsData = create((set) => ({
  reportsData: null,
  setReportsData: (data: any) => set(() => ({ reportsData: data }))
}));

export const useFiltersData = create((set) => ({
  filtersData: null,
  setFiltersData: (data: any) => set(() => ({ filtersData: data }))
}));

export const useCounter = create((set) => ({
  counter: 0,
  setCounter: (amount: number) => set(() => ({ counter: amount }))
}));

export const useAction = create((set) => ({
  action: null,
  setAction: (action: string) => set(() => ({ action: action }))
}));

export const useValidateFilters = create((set) => ({
  isSameView: false,
  setIsSameView: (isSame: boolean) => set(() => ({ isSameView: isSame }))
}));

export const useFiltersViewsOpened = create((set) => ({
  viewsOpened: null,
  setViewsOpened: (data: any) => set(() => ({ viewsOpened: data }))
}));

export const useIsBarFilersRemove = create((set) => ({
  filtersDeleted: false,
  setFiltersDeleted: (data: any) => set(() => ({ filtersDeleted: data }))
}));

export const useSelectAllFilters = create((set) => ({
  selectAllFilters: false,
  setSelectAllFilters: (data: any) => set(() => ({ selectAllFilters: data }))
}));

export const useUnSelectAllFilters = create((set) => ({
  unSelectAllFilters: false,
  setUnSelectAllFilters: (data: any) => set(() => ({ unSelectAllFilters: data }))
}));

export const useBreakDownData = create((set) => ({
  breakDownData: null,
  setBreakDownData: (data: any) => set(() => ({ breakDownData: data }))
}));

export const useUnfilteredData = create((set) => ({
  unfilterData: null,
  setUnfilterdata: (data: any) => set(() => ({ unfilterData: data }))
}));

export const useTypeCalculationChartSelected = create((set) => ({
  type: EchartOption.COUNT,
  setType: (data: string) => set(() => ({ type: data }))
}));

export const useChartSelected = create((set) => ({
  chartSelected: EchartOption.GRID,
  setChartSelected: (chart: string) => set(() => ({ chartSelected: chart }))
}));

export const useUnfilteredToggleStatus = create((set) => ({
  enableToggleUnfiltered: false,
  setUnfilteredToggleStatus: (isEnabled: any) => set(() => ({ enableToggleUnfiltered: isEnabled }))
}));

export const useTabSelected = create((set) => ({
  tabSelected: 0,
  setTabSelected: (index: number) => set(() => ({ tabSelected: index }))
}));

export const useSettingsViewList = create((set) => ({
  settingsViews: null,
  setSettingsViews: (views: any[]) => set(() => ({ settingsViews: views }))
}));

export const useReportsViewsData = create((set) => ({
  viewData: [],
  setViewData: (data: any[]) => set(() => ({ viewData: data }))
}));

export const useChecksToggleReports = create((set) => ({
  toggleChecked: false,
  setToggleChecked: (check: any) => set(() => ({ toggleChecked: check }))
}));

export const useChartSelectedReports = create((set) => ({
  chartSelected: EchartOption.GRID,
  setChartSelected: (chart: string) => set(() => ({ chartSelected: chart }))
}));

export const useChartCalculationReports = create((set) => ({
  chartCalculationSelected: EchartOption.COUNT,
  setChartCalculationSelected: (chart: string) => set(() => ({ chartCalculationSelected: chart }))
}));

export const useRationIconReports = create((set) => ({
  chartRatioSelected: EchartOption.RATIO_SUM,
  setChartRatioSelected: (chart: string) => set(() => ({ chartRatioSelected: chart }))
}));

export const useClearAllChecks = create((set) => ({
  checked: false,
  setChecked: (checked: boolean) => set(() => ({ checked: checked }))
}));

export const useSelectAllChecks = create((set) => ({
  checked: false,
  setChecked: (checked: boolean) => set(() => ({ checked: checked }))
}));

export const useRatioChecked = create((set) => ({
  checked: false,
  setChecked: (checked: boolean) => set(() => ({ checked: checked }))
}));

export const useHideCountsButtons = create((set) => ({
  hideCountsBtn: false,
  setHideCountsBtn: (checked: boolean) => set(() => ({ hideCountsBtn: checked }))
}));

export const useReportsDateFormatData = create((set) => ({
  dateReportsData: undefined,
  setDateReportsData: (data: any) => set(() => ({ dateReportsData: data }))
}));

export const useSearchTextActive = create((set) => ({
  active: null,
  setActive: (active: any) => set(() => ({ active: active }))
}));

export const useShowMoreClicks = create((set) => ({
  numberClicks: [],
  setNumberClicks: (data: any) => set(() => ({ numberClicks: data }))
}));

export const useScrollDownGrid = create((set) => ({
  scrollDown: [],
  setScrollDown: (data: any) => set(() => ({ scrollDown: data }))
}));

export const useLastDataWithShowMoreNoFilters = create((set) => ({
  dataClean: [],
  setDataClean: (data: any) => set(() => ({ dataClean: data }))
}));

export const useSelectAndNonAllValuesView = create((set) => ({
  views: [],
  setViews: (data: any) => set(() => ({ views: data }))
}));

export const useOtherDataFilteredDate = create((set) => ({
  filtered: false,
  setFiltered: (filtered: boolean) => set(() => ({ filtered: filtered }))
}));

export const useOtherDataNonFilteredDate = create((set) => ({
  filtered: false,
  setFiltered: (filtered: boolean) => set(() => ({ filtered: filtered }))
}));

export const useTypeDateChartSelected = create((set) => ({
  typeDate: EchartOption.DAY_DATE,
  setTypeDate: (data: string) => set(() => ({ typeDate: data }))
}));

export const useLoadingMyViewsPage = create((set) => ({
  loading: false,
  setLoading: (load: boolean) => set(() => ({ loading: load }))
}));

export const useCallCounter = create((set) => ({
  callCounter: false,
  setCallCounter: (load: boolean) => set(() => ({ callCounter: load }))
}));

export const useShowAIExplainerReports = create((set) => ({
  showExplainer: false,
  setShowExplainer: (showExplainer: boolean) => set(() => ({ showExplainer: showExplainer }))
}));

export const useAIExplainerReports = create((set) => ({
  explainer: '',
  setExplainer: (explainer: string) => set(() => ({ explainer: explainer }))
}));

export const useAIExplainerReportsArray = create((set) => ({
  explainer: [],
  setExplainer: (explainer: any) => set(() => ({ explainer: explainer }))
}));

export const useReportsReqAIExplainer = create((set) => ({
  request: null,
  setRequest: (request: any) => set(() => ({ request: request }))
}));

interface DistributionState {
  agg: string;
  fields: string[];
  filter: any;
}
interface DistributionStore {
  distribution: DistributionState | null;
  setDistribution: (data: Omit<DistributionState, 'agg'>) => void;
  clearDistribution: () => void;
}
export const useDistributionStore = create<DistributionStore>((set) => ({
  distribution: null,
  setDistribution: (data) =>
    set({
      distribution: {
        ...data,
        agg: 'count' // Default value
      }
    }),
  clearDistribution: () => set({ distribution: null })
}));

export const useNoRecords = create((set) => ({
  message: '',
  setMessage: (message: string) => set(() => ({ message: message })),
  clearMessage: () => set({ message: '' })
}));
